import { DefaultSeoProps } from 'next-seo'

export const SEO: DefaultSeoProps = {
  titleTemplate: '%s | pDex',
  defaultTitle: 'pDex',
  description:
    'pDEX.vision - Liquidity and trading infrastructure for the PulseChain Renaissance',
  twitter: {
    cardType: 'summary_large_image',
    handle: '@pDexSwap',
    site: '@pDexSwap',
  },
  openGraph: {
    title: 'pDex on PulseChain',
    description:
      'pDEX.vision - Liquidity and trading infrastructure for the PulseChain Renaissance',
    images: [{ url: 'https://pdex.vision/logo.png' }],
  },
}
